"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  ${props => props.copyrightInsideContainer
    ? `margin-bottom: ${props.theme.spacing.m1}px; margin-top: ${props.theme.spacing.m5}px`
    : null}
`;
exports.Link = styled_components_1.default.a `
  display: inline-block;
  cursor: pointer;
  &:not(:last-child) {
    margin-right: ${props => props.theme.spacing.m1}px;
  }
  &:hover {
    > svg {
      path {
        fill: ${props => props.theme.palette.DARK_GRAY_100};
      }
    }
  }
`;
exports.default = {
    Container: exports.Container,
    Link: exports.Link
};
